import type { MoneyPerAreaValue } from 'ComponentLibrary/src/common/money'
import type { DeviationAnalysisType, DeviationSchema } from './types'

export type DeviationAnalysisPerAreaLabels = {
    unspecifiedArea: string
    rentableArea: string
    grossFloorArea: string
    landArea: string
}

export const getPerAreaLabels = (translate: (key: string) => string): DeviationAnalysisPerAreaLabels => ({
    unspecifiedArea: translate('valuePerSquareMeter'),
    rentableArea: translate('valuePerSquareMeterRentableArea'),
    grossFloorArea: translate('valuePerSquareMeterGfa'),
    landArea: translate('valuePerSquareMeterLand'),
})

export function getLeadingValuesPerSqmDeviationAnalysis(
    deviationAnalysis: DeviationAnalysisType,
    labels: DeviationAnalysisPerAreaLabels
): DeviationSchema<MoneyPerAreaValue> & { perAreaLabel: string } {
    const methods = deviationAnalysis.base_valuation_selected_valuation_methods

    if (methods?.includes('income') || methods?.includes('investment_method') || methods?.includes('discounted_cashflow')) {
        return {
            ...deviationAnalysis.market_value_per_area.market_value_per_rentable_area,
            perAreaLabel: labels.rentableArea,
        }
    }
    if (methods?.includes('cost') || methods?.includes('comparison')) {
        return {
            ...deviationAnalysis.market_value_per_area.market_value_per_gross_floor_area,
            perAreaLabel: labels.grossFloorArea,
        }
    }
    if (methods?.includes('land_value')) {
        return {
            ...deviationAnalysis.market_value_per_area.market_value_per_land_area,
            perAreaLabel: labels.landArea,
        }
    }
    if (!methods?.length && deviationAnalysis.market_value_per_area.market_value_per_rentable_area.base_value) {
        return {
            ...deviationAnalysis.market_value_per_area.market_value_per_rentable_area,
            perAreaLabel: labels.rentableArea,
        }
    }
    if (!methods?.length && deviationAnalysis.market_value_per_area.market_value_per_gross_floor_area.base_value) {
        return {
            ...deviationAnalysis.market_value_per_area.market_value_per_gross_floor_area,
            perAreaLabel: labels.grossFloorArea,
        }
    }
    if (!methods?.length && deviationAnalysis.market_value_per_area.market_value_per_land_area?.base_value) {
        return {
            ...deviationAnalysis.market_value_per_area.market_value_per_land_area,
            perAreaLabel: labels.landArea,
        }
    }
    return {
        base_value: undefined,
        comparison_valuation: undefined,
        deviation: undefined,
        deviation_percentage: undefined,
        perAreaLabel: labels.unspecifiedArea,
    }
}
